<template>
  <button
    type="button"
    class="btn-light py-3 px-5"
    :class="[buttonClass, disabled ? '!cursor-not-allowed' : 'cursor-pointer']"
    :disabled="disabled"
  >
    <div class="text-base flex items-center justify-center text-primary" :class="buttonTextClass">
      <slot name="prefix" />
      {{ buttonText }}
      <slot name="postfix" />
    </div>
  </button>
</template>

<script lang="ts" setup>
  interface IProps {
    buttonTextClass?: string;
    disabled?: boolean;
    buttonText: string;
    buttonClass?: string;
  }

  defineProps<IProps>();
</script>

<style scoped lang="scss">
  .btn-light {
    @apply bg-white rounded-2xl ring-1 ring-inset ring-primary;

    &:hover {
      @apply opacity-60;
    }

    & .button-text {
      @apply text-primary;
    }

    &.disabled {
      @apply opacity-60 cursor-not-allowed;
    }
  }
</style>
